<template>
  <div class="block" v-if="studyTask">
    <info-row :popup="showPopup" :light-title="true" :icon="false">
      <template v-slot:image>
        <i
          class="mdi mdi-check-circle"
          :class="{ pending: !studyTask.Done }"
        ></i>
      </template>
      <template v-slot:title>
        <span data-cy="studytasks-studytask-title">{{
          studyTask.CardText
        }}</span>
      </template>
      <br />

      <template v-slot:meta>
        <div>
          <span v-if="studyTask.Action === STUDY_TASK_ACTION_TYPES.PROM">
            {{ $t('generic.questionnaire') }} {{ studyTask.PromId }}
          </span>
          <span
            v-else-if="studyTask.Action === STUDY_TASK_ACTION_TYPES.SYMPTOMS"
          >
            {{ $t('generic.SymptomReport') }}
          </span>
          <span
            v-else-if="studyTask.Action === STUDY_TASK_ACTION_TYPES.FILE_UPLOAD"
          >
            {{ $t('generic.fileUpload') }}
          </span>
          <template v-if="studyTask.Done">
            &nbsp;&bull;&nbsp; {{ $t('generic.done') }}
            {{ $filters.DateFormat(studyTask.DoneDate) }}
          </template>
        </div>
      </template>

      <!-- <template v-slot:popup>
        <template v-if="showDeletePopup">
          <div class="center">
            <div>
              <s-button
                @click.prevent.self="() => remove()"
                element-name="users-user-popup-deletebutton"
                :small="true"
                :loading="removeLoading"
                :danger="true"
                >{{ $t('generic.remove') }}</s-button
              >
              <s-button
                @click.prevent.self="() => (showDeletePopup = false)"
                element-name="users-user-popup-cancelbutton"
                :small="true"
                >{{ $t('generic.cancel') }}</s-button
              >
            </div>
          </div>
        </template>
      </template> -->
    </info-row>
  </div>
</template>

<script>
import { STUDY_TASK_ACTION_TYPES } from '@/constants';
import InfoRow from '@/views/components/InfoRow/InfoRow.vue';
import StudyTaskModel from '@/Models/StudyTaskModel';

export default {
  components: { InfoRow },
  props: {
    studyTask: {
      type: StudyTaskModel,
      required: true
    },
    active: {
      type: Boolean
    },
    removeFunction: {
      type: Function
    }
  },
  data() {
    return {
      showDeletePopup: false,
      showEditPopup: false,
      removeLoading: false,
      STUDY_TASK_ACTION_TYPES
    };
  },
  mounted() {},
  methods: {
    remove() {
      if (!this.removeFunction) {
        return;
      }
      this.removeLoading = true;
      this.removeFunction().finally(() => {
        this.removeLoading = false;
      });
    }
  },
  computed: {
    showPopup() {
      return this.showDeletePopup || this.showEditPopup;
    }
  }
};
</script>

<style lang="scss" scoped>
.pending {
  color: #ccc;
}
</style>
